import { paths } from 'src/router/paths'

export type AccountTabKey =
  | 'profile'
  | 'access'
  | 'sessions'
  | 'audit'
  | 'security'
  | 'notifications'

export type ResolvedAccountTab = {
  tab: AccountTabKey
  /** When set, the segment is a legacy alias that should redirect to this URL. */
  redirect?: string
}

// Maps a `/account/:tab` segment to its canonical tab. Legacy segments
// (authentication, audit, sessions) carry a redirect to the merged tab so old
// bookmarks keep working.
const SEGMENT_MAP: Record<string, ResolvedAccountTab> = {
  profile: { tab: 'profile' },
  access: { tab: 'access' },
  sessions: { tab: 'sessions' },
  audit: { tab: 'audit' },
  security: { tab: 'security' },
  authentication: { tab: 'security', redirect: paths.account.security },
  notifications: { tab: 'notifications' },
  activity: { tab: 'sessions', redirect: paths.account.sessions }
}

export const resolveAccountTab = (
  segment: string | undefined
): ResolvedAccountTab | null => SEGMENT_MAP[segment ?? ''] ?? null
